<template>
  <div id="infoWindow">
    <Tabs value="name1" type="card">
      <TabPane label="实时" name="name1">
        <h1 class="baidu_h1">
          <slot name="carNo"></slot>
          <car-statue :realTimeStatus="windowData.realTimeStatus"></car-statue>
          <span
            style="float: right; color: #999; font-size: 14px"
            :title="windowData.statusDuration + '分钟'"
            >{{ utils.changeTime(windowData.statusDuration) }}</span
          >
        </h1>
        <p>
          <slot name="address"></slot>
        </p>
        <ul class="msg clearfloat">
          <Row>
            <Col span="12">
              <lyFormItem label="速度" lw="3"
                >{{ windowData.speed }}km/h</lyFormItem
              >
            </Col>
            <Col span="12">
              <lyFormItem label="里程" lw="3"
                >{{ windowData.mileage }}km</lyFormItem
              >
            </Col>
            <Col span="12">
              <lyFormItem label="油量" lw="3">{{
                windowData.oilVolume == null
                  ? "未安装油针"
                  : windowData.oilVolume + "L"
              }}</lyFormItem>
            </Col>
            <Col span="12">
              <lyFormItem label="发动机" lw="4">{{
                windowData.accStatus == 0 ? "关" : "开"
              }}</lyFormItem>
            </Col>
            <span span="24">
              <lyFormItem label="GPS时间" lw="5">{{
                windowData.gpsTime
              }}</lyFormItem>
            </span>
          </Row>
        </ul>
      </TabPane>
      <TabPane
        :label="windowData.carType == 'boat' ? '船只' : '车辆'"
        name="name2"
      >
        <ul class="msg clearfloat" style="margin-top: 0">
          <Row>
            <Col span="24">
              <lyFormItem label="车辆类型">{{
                windowData.carTypeName
              }}</lyFormItem>
            </Col>
            <Col span="24">
              <lyFormItem label="设备类型">{{
                windowData.deviceTypeName
              }}</lyFormItem>
            </Col>

            <Col span="24">
              <lyFormItem label="设备号">{{ windowData.deviceNo }}</lyFormItem>
            </Col>
            <Col span="24">
              <lyFormItem label="SIM卡号">{{ windowData.simNo }}</lyFormItem>
            </Col>

            <Col span="24">
              <lyFormItem lw="5.5" label="司机 / 电话"
                >{{ utils.text(windowData.driverName, "暂无司机") }} /
                {{ utils.text(windowData.driverTel, "暂无电话") }}</lyFormItem
              >
            </Col>
            <Col span="24">
              <lyFormItem lw="7.5" label="车俩ID / 设备ID"
                >{{ windowData.carId }} / {{ windowData.deviceId }}</lyFormItem
              >
            </Col>
          </Row>
        </ul>
      </TabPane>
      <TabPane label="事件" name="name3">
        <ul class="msg clearfloat" style="margin-top: 0">
          <Row>
            <Col span="24">
              <lyFormItem label="原始经度">{{ windowData.wgs84x }}</lyFormItem>
            </Col>
            <Col span="24">
              <lyFormItem label="原始纬度">{{ windowData.wgs84y }}</lyFormItem>
            </Col>
            <Col span="24">
              <lyFormItem label="高德经度">{{ windowData.gcj02x }}</lyFormItem>
            </Col>
            <Col span="24">
              <lyFormItem label="高德纬度">{{ windowData.gcj02y }}</lyFormItem>
            </Col>
            <Col span="24">
              <lyFormItem label="事件说明">{{
                windowData.eventDesc
              }}</lyFormItem>
            </Col>
            <Col span="24">
              <lyFormItem label="报警类型">{{ windowData.alarms }}</lyFormItem>
            </Col>
          </Row>
        </ul>
      </TabPane>
    </Tabs>
    <ul class="caozuo">
      <!-- <li class="iconfont icon-changyong2" @click="track(windowData.deviceId)">
        追踪
      </li> -->
      <li>
        <slot name="btn1"></slot>
      </li>
      <li><slot name="btn2"></slot></li>
      <li><slot name="btn3"></slot></li>
      <li><slot name="btn4"></slot></li>
      <li @click="openShare()">
        <Button long>位置分享</Button>
      </li>
    </ul>
    <share ref="share"></share>
  </div>
</template>
<script>
import carStatue from "../../common/carStatue";
import share from "./share.vue";
export default {
  props: ["windowData"],
  components: { carStatue, share },
  data() {
    return {
      openVideo: false,
      isTrack: false,
    };
  },
  methods: {
    openShare() {
      this.$refs.share.open(this.windowData);
    },
    //地址解析
    oneRegeoCode(lng, lat) {
      var geocoder = new AMap.Geocoder({
        city: "010", //城市设为北京，默认：“全国”
        radius: 1000, //范围，默认：500
      });
      var that = this;
      geocoder.getAddress([lng, lat], function (status, result) {
        if (status === "complete" && result.regeocode) {
          document.getElementById(
            "address" + that.windowData.deviceId
          ).innerHTML = result.regeocode.formattedAddress;
          document.getElementById(
            "shibai" + that.windowData.deviceId
          ).style.display = "none";
        } else {
          document.getElementById(
            "shibai" + that.windowData.deviceId
          ).style.display = "block";
          log.error("根据经纬度查询地址失败");
        }
      });
    },
    //点击轨迹按钮
    changeCar(s) {
      this.$store.state.carMsg.carNum = this.windowData.num; //车牌号给客户看的
      this.$store.state.carMsg.deviceId = this.windowData.deviceId; //上传后台的参数
      this.$store.state.carMsg.select = s; //选择第几天
      this.$store.state.carMsg.lookLocusNow = true; //是否立即看轨迹
      this.$router.push({ path: "/locus?now=1" });
    },
    //点击轨迹按钮
    //点击街景按钮
    jiejing() {
      this.$emit(
        "streeData",
        this.windowData.lng,
        this.windowData.lat,
        this.windowData.address,
        true
      );
    },
    //百度街景
    lookStree() {
      this.$emit(
        "bMapStreeData",
        this.windowData.bLng,
        this.windowData.bLat,
        this.windowData.address,
        true
      );
    },
    //实时视频
    adddd(t) {
      console.log(t);
      //this.openVideo=true;
      //this.$refs.vueVideo.createPlayer();
      //this.$Message.info("即将开放，敬请期待");
      //console.log(t.deviceType.indexOf("视频"));
      if (t.deviceTypeName.indexOf("视频") == -1) {
        this.$Message.warning({
          content: "未安装视频",
          duration: 2,
        });
      } else {
        this.$emit("video", t.deviceNo);
      }
    },
    //最终车辆
    track(m) {
      //this.isTrack=!this.isTrack;
      this.$emit("track", m);
      /* if (this.isTrack) {
        this.$emit("track",m)
      }else{
        this.$emit("cancelTrack")
      } */
      //document.getElementById('track'+99).innerHTML='我来了'
      //document.getElementById('track'+t).innerHTML='我没有'
      //
    },
    huifang(v) {
      console.log(v);
      this.$router.push({
        path: "/locus",
      });
      this.$store.state.carMsg = v;
      this.$store.state.carMsg.play = 1;
    },
    mounted() {
      //console.log(this.num,this.devicenum)
    },
  },
  watch: {
    windowData(x) {
      //this.isTrack=false;
    },
  },
  mounted() {
    // console.log(this.windowData.carPoundList);
  },
};
</script>
<style lang="">
.baidu_h1 {
  font-size: 1.3em;
  color: #333;
  margin-top: 0;
  font-weight: 500;
  margin-bottom: 6px;
  margin-left: 0px;
}

.msg {
  margin-top: 4px;
  width: 100%;
  line-height: 1;
}
.msg label {
  margin-right: 6px;
  color: #999;
}
.msg span {
  color: #333;
  margin-right: 6px;
  font-size: 12px;
}
.caozuo {
  display: flex;
  margin-top: 8px;
  padding-left: 0px;
}
.caozuo li {
  margin-right: 10px;
  position: relative;
}
.caozuo li.iconfont::before {
  margin-right: 0px;
  color: #5a94ff;
}
.caozuo li:nth-child(2).iconfont::before {
  margin-right: 2px;
  color: #ff6161;
}
.caozuo li:nth-child(3).iconfont::before {
  margin-right: 2px;
  color: #1ad132;
}
.caozuo li:last-child {
  margin-right: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/locate/com/iconWindow.vue